// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1aMdw","container":"styles_container__1CGhq","title":"styles_title__23bUW","wrapper":"styles_wrapper__315_b","answer":"styles_answer__2TTX1"};